import Image from 'app/Components/Shared/Image/image';
import React, { useState } from "react";
import arrowLeft from './images/carousel-arrow-left.svg'
import arrowRight from './images/carousel-arrow-right.svg'
import disableArrowLeft from './images/carousel-arrow-disable-left.svg'

const Carousel = ({ items , maxToDisplay}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayItems, setDisplayItems] = useState(items.slice(0, maxToDisplay));

  const isDisableArrow = items.length==currentIndex + maxToDisplay;
  const handlePrev = () => {
    let prevIndex=currentIndex-1;
    setCurrentIndex(prevIndex);
    setDisplayItems(items.slice(prevIndex, maxToDisplay - prevIndex));
  };
  const handleNext = () => {
    let nextIndex=currentIndex +1;
    setCurrentIndex(nextIndex);
    setDisplayItems(items.slice(nextIndex, nextIndex + maxToDisplay));
  };

  return (
    <>
      <Image className={`carousel-arrow-icon ${currentIndex >=1 ? 'visible':'hidden'}`}  src={arrowRight} onClick={handlePrev} />
      {displayItems.map((item) =>
         {return(<div key={item.key} >{item}</div>)}
     )}
      {
        isDisableArrow ?
        <Image className="carousel-arrow-icon disable" src={disableArrowLeft} /> :
        <Image className="carousel-arrow-icon enable" src={arrowLeft} onClick={handleNext} />
      }
      </>
  );
};
export default Carousel;
